module.exports = __webpack_public_path__ + "img/serveItem2.1a4b953e.png";